/* eslint-disable */
// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type LetterPageByUsernameQueryVariables = Types.Exact<{
  letter?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type LetterPageByUsernameQuery = {
  __typename?: 'Query';
  peopleTopLevelPage?: {
    __typename?: 'PeopleTopLevelPage';
    letter?: string | null;
    breadcrumbs?: Array<{
      __typename?: 'PeopleBreadcrumbsItem';
      title?: string | null;
      url?: string | null;
    } | null> | null;
    names?: Array<
      | {
          __typename?: 'PeopleChildItem';
          name?: string | null;
          toName?: string | null;
          url?: string | null;
        }
      | {
          __typename?: 'PeopleProfileItem';
          name?: string | null;
          photoUrl?: string | null;
          coach?: boolean | null;
          url?: string | null;
          occupationTitle?: string | null;
          city?: string | null;
        }
      | {
          __typename?: 'PeopleUserBagItem';
          name?: string | null;
          url?: string | null;
          count?: number | null;
        }
      | null
    > | null;
    popularNames?: Array<{
      __typename?: 'PeopleUserBagItem';
      name?: string | null;
      url?: string | null;
      count?: number | null;
    } | null> | null;
  } | null;
};

export const LetterPageByUsernameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LetterPageByUsername' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'letter' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'peopleTopLevelPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'letter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'letter' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'letter' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'breadcrumbs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'names' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'PeopleNames' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'popularNames' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PeopleNames' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PeopleDirectoryItem' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PeopleProfileItem' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'photoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'coach' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'occupationTitle' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PeopleChildItem' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'toName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PeopleUserBagItem' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LetterPageByUsernameQuery,
  LetterPageByUsernameQueryVariables
>;
